import React from "react";
import { Burger, Flex, Group } from "@mantine/core";
import { useLayout } from "@layout";
import ModeSwitcher from "./ModeSwitcher";
import LanguageSwitcher from "./LanguageSwitcher";
import Notifications from "./Notifications";
import UserAvatar from "./UserAvatar";

const Header = () => {
  const { mobileOpened, toggleMobile, toggleDesktop } = useLayout() /* prettier-ignore */

  return (
    <Flex align={"center"} p={"0.5rem"} className="h-full">
      <Burger opened={mobileOpened} hiddenFrom="sm" onClick={toggleMobile} />
      <Burger visibleFrom="sm" onClick={toggleDesktop} />
      <Group ms={"auto"}>
        <LanguageSwitcher />
        <ModeSwitcher />
        <Notifications />
        <UserAvatar />
      </Group>
    </Flex>
  );
};

export default Header;
